<template>
  <b-dropdown class="d-inline-flex mx-1" size="sm" text="tags">
    <div class="scrollable">
      <b-list-group>
        <b-list-group-item disabled v-if="auth" class="nowrap">
          <div class="flex-row">
            <span class="symbol" style="cursor:pointer" @click="add_tag">&#x2b;</span>
            <input v-focus autocomplete="off" placeholder="Add tag..." v-model="new_tag" @keyup.enter="add_tag">
          </div>
        </b-list-group-item>

        <template v-for="tag,tagid in get_tags">
          <b-list-group-item class="nowrap" disabled :key=tag.id>
            <div class="flex-row">
              <span class="symbol" v-if="auth" style="cursor:pointer" @click="e=>{edit_tag(tag,tagid)}">&#x270E;</span>
              <b v-if="edit_id!==tagid" v-model="edit_content">{{tag}}</b>
              <input v-focus @keyup.enter="done" v-if="edit_id==tagid" v-model="edit_content">
            </div>
          </b-list-group-item>
          </template>
      </b-list-group>
    </div>
  </b-dropdown>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

import * as d3 from 'd3'

import utils from '../utils'

const focus = {
  inserted(el) {
    el.focus()
  },
}

export default {
  name:'TagList',
  props: ['node','tags','name'],
  components: {},
  data () {
    return {
      new_tag:"",
      edit_store:"",
      edit_content:"",
      edit_id:null
    }
  },
  directives: { focus },
  computed:{
    ...mapState({
      auth: state => state.backend.isAuthenticated,
      sigfig: state => state.sigfig
    }),
    get_tags(){
      return this.node.get_tags()
    },
  },

  methods:{
add_tag(){
if(this.new_tag.length){
this.node.children.forEach(n=>{
Vue.set(n.tags,this.new_tag,1)
})
        this.new_tag=""
      }
    },
    edit_tag(t,id){
      this.edit_store = t
      this.edit_content = t
      this.edit_id = id
    },
    done(){
      //TODO: update children node tags accordingly here
      this.node.children.forEach(n=>{
        var tmp=1
        if(n.tags[this.edit_store]!==null){
          tmp = n.tags[this.edit_store]
          delete n.tags[this.edit_store]
        }
        Vue.set(n.tags,this.edit_content,tmp)
      })
      this.edit_store=""
      this.edit_content=""
      this.edit_id=null
    },
    clickout(e){
      this.done()
    }
  }
}
  </script>

<style scoped>

.dropdown >>> .show {
      padding-top:0px;
      padding-bottom:0px;
}

.nowrap{
    white-space: nowrap;
    padding:5px;
}

.scrollable{

    height:auto;
    max-height:450px;
    overflow-y: auto;
}

.linkref{
    font-size:11px;
}

.symbol{
    font-size:12px;
}

.edit{
    width:100%;
}

</style>



// WEBPACK FOOTER //
// src/components/TagList.vue